// extracted by mini-css-extract-plugin
module.exports = {"reviews":"Reviews_reviews__vGyDZ","embedded":"Reviews_embedded__7UQmn","noReviews":"Reviews_noReviews__0lqTx"};